module.exports = __webpack_public_path__ + "static/media/3.d5d8d4cc.jpg";